import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IFormMasterBuilder } from '../../../form-master/form-master.interface';

@Injectable()
export class LoginBuilder implements IFormMasterBuilder {
  FORM_KEYS = {
    USERNAME: 'username',
    PASSWORD: 'password',
  };

  constructor(private _formBuilder: FormBuilder) {}

  buildForm(): FormGroup {
    return this._formBuilder.group({
      [this.FORM_KEYS.USERNAME]: ['', Validators.required],
      [this.FORM_KEYS.PASSWORD]: [
        '',
        [Validators.required, Validators.minLength(6)],
      ],
    });
  }
}
